import React from 'react';
import fromNow from '../../helpers/fromNow';
import WarningParagraph from '@resources/js/components/WarningParagraph/WarningParagraph';
import cx from 'classnames';

const formatter = new Intl.NumberFormat('en-US');

type Props = {
  lastUpdatedLabel: string;
  lastUpdated: string | null;
  totalParsesLabel: string;
  totalParses: number;
  metadataSummaryDescription: string;
  warning: string | null;
};

export default function BuildsMetadataSummary({
  lastUpdatedLabel,
  lastUpdated,
  totalParsesLabel,
  totalParses,
  metadataSummaryDescription,
  warning,
}: Props): JSX.Element | null {
  if (!totalParses) {
    return null;
  }

  return (
    <div className={'builds-metadata-summary'}>
      <div className={'builds-metadata-summary__content'}>
        <span>
          <span>{lastUpdatedLabel}:</span>{' '}
          <span
            className={'builds-metadata-summary__data'}
            suppressHydrationWarning // due to fromNow being rel. to viewer timezone
          >
            {lastUpdated ? fromNow(new Date(lastUpdated)) : <em>Never</em>}
          </span>
        </span>
        <span>
          <span>{totalParsesLabel}:</span>{' '}
          <span
            className={cx({
              'builds-metadata-summary__data': true,
              'builds-metadata-summary__data--warning': warning,
            })}
          >
            {formatter.format(totalParses)}
          </span>
        </span>
        <span>{metadataSummaryDescription}</span>
      </div>
      {warning && <WarningParagraph style={'red'}>{warning}</WarningParagraph>}
    </div>
  );
}
